export const MAIN_BG_COLOR = 'rgb(90,192,234)';

export const MAIN_TXT_COLOR = 'white';

export const BTN_CLS = {
	borderWidth: 1,
	borderRadius: 10,
	paddingVertical: 8,
	paddingHorizontal: 16,
	width: '100%',
};


export const MAIN_BORDER_COLOR = {borderColor:'rgb(90,192,234)'};
export const MAIN_BORDER_COLOR_STRING = 'rgb(90,192,234)'

export const ROUND_BORDER_COLOR = `rounded border ${MAIN_BORDER_COLOR_STRING}`;

export function cx(...inputs: any[]): any[] {
	const filteredInputs = Array.isArray(inputs[0]) ? inputs[0] : [...inputs];
	return filteredInputs
		.filter(Boolean)
		.map((item) => (typeof item === 'object' ? item : { [item]: true }));
}

